import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-semibold tracking-[-0.01em] ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:translate-y-px disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border border-primary-700 bg-primary-700 text-white shadow-[0_10px_24px_-14px_rgba(8,122,88,.8)] hover:-translate-y-0.5 hover:border-primary-800 hover:bg-primary-800 hover:shadow-[0_16px_30px_-14px_rgba(8,122,88,.72)]",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-primary-300 bg-white/90 text-primary-700 shadow-[0_8px_20px_-16px_rgba(8,122,88,.55)] hover:-translate-y-0.5 hover:border-primary-400 hover:bg-primary-50 hover:shadow-[0_14px_26px_-16px_rgba(8,122,88,.45)]",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "border border-transparent hover:-translate-y-0.5 hover:bg-primary-100/80 hover:text-primary-700 hover:shadow-[0_10px_22px_-18px_rgba(8,122,88,.5)]",
        link: "text-primary underline-offset-4 hover:underline",
        green: "border border-primary-700 bg-primary-700 text-white shadow-[0_10px_24px_-14px_rgba(8,122,88,.8)] hover:-translate-y-0.5 hover:border-primary-800 hover:bg-primary-800 hover:shadow-[0_16px_30px_-14px_rgba(8,122,88,.72)]",
        "green-outline": "border border-primary-300 bg-white/90 text-primary-700 shadow-[0_8px_20px_-16px_rgba(8,122,88,.55)] hover:-translate-y-0.5 hover:border-primary-400 hover:bg-primary-50 hover:shadow-[0_14px_26px_-16px_rgba(8,122,88,.45)]",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-lg px-3.5 text-xs",
        lg: "h-12 rounded-xl px-8",
        icon: "h-10 w-10 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? "span" : "button";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = "Button";

export { Button, buttonVariants };
